import { render, staticRenderFns } from "./uploadzip.vue?vue&type=template&id=59235d03&"
import script from "./uploadzip.vue?vue&type=script&lang=js&"
export * from "./uploadzip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports